<template>
  <div :class="['tree-node', node.children.length == 0 ? 'listChild' : '', is_review ? 'reviewRow' : '']">
    <div>
      <b-checkbox v-if="node.children.length == 0 && select_mode" v-model="node.selected"></b-checkbox>
      <img class="recycleBin" v-if="node.name == 'Recycle Bin'" src="../../assets/RecycleBin.png" />
      <i v-else-if="node.children.length > 0"
        :class="['node-icon folder', isCollapsed ? 'fas fa-folder' : 'fas fa-folder-open']"></i>
      <i v-else :class="['node-icon', getFileIcon(node)]"></i>
      <span :class="node.children.length > 0 ? 'node-folder' : ''" v-on:click="toggleCollapse">{{ node.name }}</span>
      <span v-if="node.children.length == 0 && !is_review" v-on:click="toggleCollapse"> &emsp; {{
        formatDateTime(node.lastModified)
        }}</span>
      <img v-if="node.children.length == 0 && !node.isRecycleBin && !select_mode && !is_review"
        v-on:click="renameDocument(node)" src="../../assets/RenameIcon.png" class="renameAction" v-b-tooltip.hover
        title="Rename" />
      <i v-if="node.children.length == 0 && !node.isRecycleBin && !select_mode && !is_review"
        class="fa-solid fa-download downloadAction" :style="{ 'margin-right': node.isRecycleBin ? '3px' : '10px' }"
        v-on:click="downloadDocument(node)" v-b-tooltip.hover title="Download"></i>
      <i v-if="node.children.length > 0 && !node.isRecycleBin && !node.isRoot && !select_mode && !is_review"
        class="fa-solid fa-upload uploadAction" v-on:click="onUploadItem(node)" v-b-tooltip.hover title="Upload"></i>
      <i v-if="node.children.length == 0 && !node.isRecycleBin && !select_mode && !is_review"
        class="fa-solid fa-trash deleteAction" v-on:click="deleteDocument(node)" v-b-tooltip.hover title="Delete"></i>
      <i v-if="node.children.length == 0 && node.isRecycleBin && !select_mode && !is_review"
        class="fa-solid fa-trash deletePermanentlyAction" v-on:click="deleteDocumentPermanently(node)" v-b-tooltip.hover
        title="Delete permanently"></i>
      <img v-if="node.isRecycleBin && node.children.length == 0 && !select_mode" v-on:click="undoTrash(node)"
        src="../../assets/TrashUndo.png" class="undoTrashAction" v-b-tooltip.hover title="Restore" />
      <b-button class="reviewBtn" v-if="node.children.length == 0 &&  is_review"
        @click="reviewDocument(node)">
        Review
      </b-button>
      <b-button v-if="node.children.length == 0 &&  is_review"
        @click="downloadDocument(node)">
        Download
      </b-button>
      <b-button v-if="node.children.length == 0 &&  is_review"
        @click="onOverrideItem(node)">
        Upload
      </b-button>
      <b-button v-if="node.children.length == 0 &&  is_review"
        @click="saveChanges(node)">
        Save changes
      </b-button>
      <b-button class="approveBtn" v-if="node.children.length == 0 && is_review"
        @click="approveDocument(node)">
        Approve
      </b-button>
      <b-button class="rejectBtn" v-if="node.children.length == 0 && is_review"
        @click="rejectDocument(node)">
        Reject
      </b-button>
      <label class="approveValue" v-if="node.children.length == 0 && is_review && node.reviewStatus == 1">approved</label>
      <label class="rejectValue" v-if="node.children.length == 0 &&  is_review && node.reviewStatus == 2">rejected</label>
    </div>

    <ul v-if="!isCollapsed && node.children.length > 0">
      <DocumentExplorerTreeNode v-for="child in node.children" :key="child.name" :node="child"
        v-on:upload="onUploadItem" v-on:override="onOverrideItem" v-on:delete="deleteDocument" v-on:deletePermanently="deleteDocumentPermanently"
        v-on:rename="renameDocument" v-on:unDelete="undoTrash" v-on:download="downloadDocument" v-on:reviewDocument="reviewDocument" v-on:saveChanges="saveChanges"
        :select_mode="select_mode" :is_reviewer="is_reviewer" :is_review="is_review" v-on:approveDocument="approveDocument" v-on:rejectDocument="rejectDocument"/>
    </ul>

  </div>
</template>

<script>
export default {
  name: 'DocumentExplorerTreeNode',
  props: {
    node: Object,
    select_mode: Boolean,
    is_reviewer: Boolean,
    is_review: Boolean,
  },
  data() {
    return {
      isCollapsed: false
    };
  },
  methods: {
    formatDateTime(dateTime) {
      dateTime = new Date(dateTime).toLocaleString(navigator.language, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      return dateTime;
    },
    reviewDocument(document) {
      this.$emit('reviewDocument', document);
    },
    saveChanges(document) {
      this.$emit('saveChanges', document);
    },
    approveDocument(document){
      this.$emit('approveDocument', document);
    },
    rejectDocument(document){
      this.$emit('rejectDocument', document);
    },
    getFileIcon(file) {
      var className = "";
      var extension = file.name.split('.').pop();
      switch (extension.toLowerCase()) {
        case "pdf":
          className = "fas fa-file-pdf filePdfColor";
          break;
        case "txt":
        case "csv":
        case "xdtxt":
          className = "fas fa-file-alt fileTxtColor";
          break;
        case "xml":
          className = "fas fa-file-code fileXmlColor";
          break;
        case "config.xml":
          className = "fas fa-file-code fileConfigXmlColor";
          break;
        case "doc":
        case "docx":
        case "docm":
          className = "fas fa-file-word fileWordColor";
          break;
        case "xls":
        case "xlsx":
        case "xlsm":
          className = "fas fa-file-excel fileExcelColor";
          break;
        case "html":
        case "htm":
          className = "fab fa-html5 fileHtmlColor";
          break;
        case "pps":
        case "pptx":
          className = "fas fa-file-powerpoint filePowerPointColor";
          break;
        case "mdb":
        case "accdb":
          className = "fas fa-database";
          break;
        case "bmp":
        case "gif":
        case "png":
        case "tiff":
        case "tif":
        case "ico":
        case "pcx":
        case "jpeg":
        case "jpg":
        case "emf":
        case "wmf":
          className = "fas fa-image";
          break;
        case "eml":
          className = "fas fa-envelope outlookColor";
          break;
        default:
          className = "fas fa-file-alt";
      }
      return className;
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      this.$nextTick(() => {
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
      });
    },
    downloadDocument(document) {
      this.$emit('download', document);
    },
    onOverrideItem(document){
      this.$emit('override', document);
    },
    onUploadItem(document) {
      this.$emit('upload', document);
    },
    deleteDocumentPermanently(document) {
      this.$emit('deletePermanently', document);
    },
    deleteDocument(document) {
      this.$emit('delete', document);
    },
    renameDocument(document) {
      this.$emit('rename', document);
    },
    undoTrash(document) {
      this.$emit('unDelete', document);
    },
    onUpdateDocuments(){
      this.$emit('updateDocuments', document);
    }
  }
};
</script>

<style scoped>
.recycleBin {
  width: 20px;
  margin-right: 5px;
}

.tree-node {
  margin-left: 10px;
}

.folder {
  color: #ffcc29;
}

.filePdfColor {
  color: #C8280A;
}

.fileExcelColor {
  color: #008a00;
}

.fileXmlColor {
  color: #24306A;
}


.fileWordColor {
  color: #185abd;
}

.outlookColor {
  color: #0072C6;
}

.fileHtmlColor {
  color: #FF5722
}

.filePowerPointColor {
  color: #b6472b;
}

.node-folder {
  cursor: pointer;
}

.node-icon {
  margin-right: 5px;
}

.listChild {
  padding-left: 20px;
}

.listChild:hover {
  background-color: lightgray;
}

.downloadAction {
  padding-top: 5px;
  cursor: pointer;
}

.uploadAction {
  cursor: pointer;
  margin-left: 10px;
}

.deleteAction {
  cursor: pointer;
  padding-top: 5px;
  margin-right: 10px;
}

.deletePermanentlyAction {
  cursor: pointer;
  padding-top: 5px;
  margin-left: 7px;
}

.renameAction {
  margin-left: 10px;
  cursor: pointer;
  margin-right: 10px;
  height: 19px;
  width: 20px;
}

.undoTrashAction {
  width: 29px;
  height: 29px;
  margin-bottom: 2px;
  cursor: pointer;
}

.custom-checkbox {
  display: inline;
  padding-left: 0px;
}

.reviewBtn {
  margin-left: 15px;
}

.approveValue{
  margin-left: 15px;
  color: green;
}

.rejectValue{
  margin-left: 15px;
  color: red;
}

.approveBtn{
  color: green;
}

.rejectBtn{
  color: red;
}

.reviewRow{
  margin-top: 5px;
}
</style>
